//--------------------------------------------------------------------------------
//
// AIO Session UI entry point
//
//--------------------------------------------------------------------------------

import "../assets/normalize.css";
import "../assets/app.less";
import "@fortawesome/fontawesome-free/css/all.css";

import { runApp, usePayments } from "../lib/app.js";
import { Elm } from "./Main.elm";

async function main() {
    const app = await runApp({
        elmApp:     Elm.App.Main,
        isMobile:   false,
        getToken:   null,
        setToken:   null,
        clearToken: null,
    });
    usePayments(app);
}

main();

//--------------------------------------------------------------------------------
